import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=0a90cc0e&scoped=true&"
import script from "./Appointment.ts?vue&type=script&lang=ts&"
export * from "./Appointment.ts?vue&type=script&lang=ts&"
import style0 from "./Appointment.scss?vue&type=style&index=0&id=0a90cc0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90cc0e",
  null
  
)

export default component.exports